<template>
  <scrollactive
    active-class="active"
    :offset="0"
    :duration="1500"
    bezier-easing-value=".5,0,.35,1"
    :always-track="true"
    :click-to-scroll="true"
    type="String"
  >
    <footer>
      <div class="container">
        <div class="content_footer">
          <div class="content_small">
            <img
              src="@/assets/logo_wagner_ramos.png"
              alt="Logo Footer Portfolio Wagner Ramos"
              loading="lazy"
              data-aos="zoom-in"
              data-aos-delay="1000"
            />
          </div>

          <div class="content_small">
            <ul>
              <li>
                <router-link to="#banner" custom class="scrollactive-item"
                  >Home</router-link
                >
              </li>
              <li>
                <router-link to="#sobre" custom class="scrollactive-item"
                  >Sobre
                </router-link>
              </li>
              <li>
                <router-link to="#jobs" custom class="scrollactive-item"
                  >Jobs</router-link
                >
              </li>
              <li>
                <router-link to="#expertises" custom class="scrollactive-item"
                  >Expertises</router-link
                >
              </li>
            </ul>
          </div>

          <div class="content_small">
            <p>São Paulo - Brasil</p>
            <p><strong>Telefone:</strong><span>+ 55 11 9 6574 5723</span></p>
            <p><strong>Email:</strong><span>qa302655@gmail.com</span></p>
            <div class="lk-contacts">
              <router-link
                :to="{ name: 'github' }"
                title="Github"
                custom
                target="_blank"
              >
                <font-awesome-icon :icon="['fab', 'github']" />
              </router-link>
              <router-link
                custom
                :to="{ name: 'linkedin' }"
                title="Linkedin"
                target="_blank"
              >
                <font-awesome-icon :icon="['fab', 'linkedin']" />
              </router-link>
              <router-link
                custom
                to="/cv.pdf"
                title="Download CV"
                target="_blank"
              >
                <font-awesome-icon :icon="['fa', 'file']" />
              </router-link>
            </div>
          </div>

          <div class="content_small">
            <p class="copy">© Wagner Ramos {{ new Date().getFullYear() }}</p>
          </div>
        </div>
      </div>
    </footer>
  </scrollactive>
</template>

<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};
</script>
